export const SET_AUTH_TRUE = "SET_AUTH_TRUE";
export const SET_AUTH_FALSE = "SET_AUTH_FALSE";
